import { useEffect } from 'react';
import type { Event } from 'effector';

const useEventWatcher = <T>(event: Event<T>, cb: (val: T) => any) => {
  useEffect(() => {
    return event.watch((payload) => {
      cb(payload);
    });
  });
};

export default useEventWatcher;
